/**
 * お気に入り・再入荷・マイページ API デバッグパネル
 *
 * 常時 ON: snippets/ganymede-debug-panel.liquid の GanymedeDebug.force = true
 * 任意 ON: ?ganymede_debug=1 または localStorage.ganymedeDebug=1
 */
(function () {
  'use strict';

  var MAX_LOG_LINES = 40;

  function isEnabled() {
    try {
      if (window.GanymedeDebug && window.GanymedeDebug.force) {
        return true;
      }
      if (/[?&]ganymede_debug=1(?:&|$)/.test(String(window.location.search || ''))) {
        return true;
      }
      if (window.localStorage && localStorage.getItem('ganymedeDebug') === '1') {
        return true;
      }
    } catch (e) {
      /* ignore */
    }
    return false;
  }

  function panel() {
    return document.getElementById('ganymede-debug-panel');
  }

  function logEl() {
    return document.getElementById('ganymede-debug-log');
  }

  function setText(id, text) {
    var el = document.getElementById(id);
    if (el) {
      el.textContent = text;
    }
  }

  function showPanel() {
    var p = panel();
    if (p) {
      p.hidden = false;
    }
  }

  function appendLine(html) {
    var box = logEl();
    if (!box) {
      return;
    }
    var line = document.createElement('div');
    line.className = 'ganymede-debug__line';
    line.innerHTML = html;
    box.insertBefore(line, box.firstChild);
    while (box.children.length > MAX_LOG_LINES) {
      box.removeChild(box.lastChild);
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function formatJson(obj) {
    try {
      return escapeHtml(JSON.stringify(obj, null, 2));
    } catch (e) {
      return escapeHtml(String(obj));
    }
  }

  function now() {
    return new Date().toLocaleTimeString('ja-JP', { hour12: false });
  }

  window.GanymedeDebug = window.GanymedeDebug || {};

  window.GanymedeDebug.isEnabled = isEnabled;

  window.GanymedeDebug.log = function (title, detail) {
    if (!isEnabled()) {
      return;
    }
    showPanel();
    var body =
      detail !== undefined
        ? '<pre class="ganymede-debug__pre">' + formatJson(detail) + '</pre>'
        : '';
    appendLine(
      '<strong>[' +
        escapeHtml(now()) +
        '] ' +
        escapeHtml(title) +
        '</strong>' +
        body
    );
  };

  /**
   * @param {string} label
   * @param {string} url
   * @param {Response} res
   * @param {object} requestBody
   * @param {string} responseText
   * @param {object|null} parsed
   */
  window.GanymedeDebug.logApi = function (label, url, res, requestBody, responseText, parsed) {
    if (!isEnabled()) {
      return;
    }
    showPanel();
    var status = res ? res.status : '?';
    var ok = parsed && parsed.ok;
    var color = res && res.ok && ok !== false ? '#060' : '#c00';
    appendLine(
      '<strong style="color:' +
        color +
        '">[' +
        escapeHtml(now()) +
        '] ' +
        escapeHtml(label) +
        ' HTTP ' +
        escapeHtml(status) +
        '</strong>' +
        '<div>URL: ' +
        escapeHtml(url) +
        '</div>' +
        (requestBody
          ? '<pre class="ganymede-debug__pre">req: ' + formatJson(requestBody) + '</pre>'
          : '') +
        '<pre class="ganymede-debug__pre">res: ' +
        escapeHtml(String(responseText || '').slice(0, 1200)) +
        '</pre>'
    );
    setText('ganymede-debug-last', label + ' → ' + status);
  };

  window.GanymedeDebug.setStatus = function (key, value) {
    if (!isEnabled()) {
      return;
    }
    setText('ganymede-debug-' + key, value);
    showPanel();
  };

  function init() {
    if (!isEnabled()) {
      return;
    }
    showPanel();
    window.GanymedeDebug.log('debug panel ON', {
      page: window.location.pathname,
      customerLoggedIn: !!(window.GanymedeDebug && window.GanymedeDebug.customerLoggedIn),
      customerId: window.GanymedeDebug && window.GanymedeDebug.customerId,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
